<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter" id="structure_1" role="doc-chapter">
<figure class="figure" id="struc1">
<p class="fig"><span aria-label="7" class="page" epub:type="pagebreak" id="p7" role="doc-pagebreak"></span><img alt="" height="149" src="images/Mitchell_Amasia.jpg" width="150"/></p>
</figure>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-mitchell-0010.vue?2fdd79bd